import React, { useState } from 'react'
import { Simulator } from '../../../components/Simulator'
import { useNavigate } from 'react-router-dom';
import { ShowVideo } from '../components/Header/ShowVideo';
import { ProjectOfferSlider, ShowVideoInSimulator } from '../components/Header';

export const Header = () => {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const handleVideo = () => {
        setShowModal(!showModal);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
    return (
        <>
            <div className='mt-[60px] lg:mt-[70px] h-auto flex flex-col lg:flex-row justify-between items-start px-[5%] pt-5 bg-white'>
                <div className='h-auto w-full lg:w-[37%]'>
                    <h2 className='primaryFont text-[#3533FF] text-xl font-semibold flex cursor-pointer' onClick={handleVideo}>
                        <svg className='mr-2 w-5 h-5 ml-3 fill-current translate-y-1' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z" /></svg>
                        Que es LOKL?
                    </h2>
                    <h1 className='primaryFont mt-4 font-roboto text-4xl text-black font-bold'>Inversiones inmobiliarias para las nuevas generaciones</h1>
                    <h2 className='secondaryFont mt-6 lg:mt-2 text-xl font-light text-black'>Invierte en proyectos inmobiliarios con alto potencial de rentabilidad y valorización hechos para ti</h2>
                    <ProjectOfferSlider />
                    <button id='newprojects' onClick={() => navigate(`/project/nido-de-agua`)} className='primaryFont mt-6 mb-6 bg-black rounded-full text-white font-semibold px-5 py-3 text-2xl'>Empieza a Invertir</button>
                </div>
                <div className='h-auto w-full lg:w-[61%] relative'>
                    <ShowVideoInSimulator showModal={showModal} handleClose={handleCloseModal} />
                    {!showModal && <Simulator />}
                </div>
                <ShowVideo showModal={showModal} handleClose={handleCloseModal} /> 
            </div>
        </>
    )
}
